import React, { useState } from 'react'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Stack from 'components_new/atoms/Stack'

import SettingsItem from 'components_new/molecules/SettingsItem'
import SettingsGroup from 'components_new/molecules/SettingsGroup'

import EditDialog from './EditDialog'
import ReOrderItem from './ReOrderItem'

import { TWidgetSettings, WidgetType } from 'types/GlobalWidget'
import { TPutFunnelStages } from 'redux/api/Widgets/types'

interface ReOrderSectionProps {
  putFunnelStages: (data: TPutFunnelStages) => void
  settings: TWidgetSettings
}

const LEGAL_TYPES = [WidgetType.FUNNEL]

const ReOrderSection = (props: ReOrderSectionProps) => {
  const { putFunnelStages, settings } = props
  const { t } = useTranslation()

  const [editDialogOpen, setEditDialogOpen] = useState(false)

  if (!LEGAL_TYPES.includes(settings.type.selected)) {
    return null
  }

  const stages = settings.segment_by.stages

  return (
    <>
      <SettingsGroup title={t('widgets', 'sorting_title')}>
        <SettingsItem>
          <Box sx={{ width: '100%' }}>
            <Stack sx={{ height: 128, mb: 1 }}>
              {stages.map((stage) => (
                <Box
                  key={stage.index}
                  sx={{
                    height: '100%',
                    width: '100%',
                    minWidth: 0,
                    p: 0.5
                  }}
                >
                  <ReOrderItem
                    editable={false}
                    hidden={stage.hidden}
                    setHidden={() => {}}
                    status={stage.status}
                    setStatus={() => {}}
                    title={stage.title}
                  />
                </Box>
              ))}
            </Stack>
            <Button
              onClick={() => setEditDialogOpen(true)}
              fullWidth={true}
              variant="text"
            >
              {t('global', 'edit')}
            </Button>
          </Box>
        </SettingsItem>
      </SettingsGroup>

      <EditDialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        updateEvents={putFunnelStages}
        funnelStages={stages}
      />
    </>
  )
}

export default ReOrderSection
